import { useTranslation } from 'react-i18next';
import BrandLoader from '@/components/BrandLoader';

// Mappe l'ancienne prop `color` vers une classe Tailwind qui pilote
// `currentColor` du BrandLoader. 'navy' = défaut (navy clair / crème sombre).
const COLOR_CLASS = {
  navy: '',
  white: 'text-cream-50',
  bordeaux: 'text-bordeaux-700',
  gold: 'text-gold-500',
  current: 'text-current',
};

/**
 * Spinner de chargement — délègue au <BrandLoader/> (anneau + logo Inside Panama).
 * API conservée (size, color, label, className) pour les appels existants
 * (RouteFallback, AdminDashboard, widgets Home…).
 */
export default function LoadingSpinner({ size = 32, color = 'navy', label, className = '' }) {
  const { t } = useTranslation();
  const a11y = label ?? t('common:loading');
  const colorCls = COLOR_CLASS[color] ?? '';
  return <BrandLoader size={size} label={a11y} className={`${colorCls} ${className}`.trim()} />;
}
